import React from "react";
import { Routes, Route } from "react-router-dom";
import { Login, LoginOTP, Logout, Register, RegisterOTP } from "../pages/Auth";
import { Main } from "../pages/Main";

import UserLogin from "../pages/UserLogin";
import RegisterUserOTP from "../pages/RegisterUserOTP";
import LoginUserOTP from "../pages/LoginUserOTP";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      {/* <Route path="/login" element={<Login />} />
      <Route path="/login-otp" element={<LoginOTP />} /> */}
      <Route path="/register" element={<Register />} />
      {/* <Route path="/register-otp" element={<RegisterOTP />} /> */}
      <Route path="/logout" element={<Logout />} />

      {/* New Routes */}
      <Route path="/user-login" element={<UserLogin />} />
      <Route path="/register-user-otp" element={<RegisterUserOTP />} />
      <Route path="/login-user-otp" element={<LoginUserOTP />} />
    </Routes>
  );
}
